<template>
    <Dialog
        :value="true"
        :header-text="$t('Email settings')"
        persistent
        :width="700"
        @close_modal="$emit('close')"
    >
        <v-row>
            <v-col cols="12" class="pt-0 pb-2">
                <text-field
                    :label="$t('Email address')"
                    :value="emailIntegration.email"
                    disabled
                />
            </v-col>
            <v-col cols="12" class="pt-0 pb-2">
                <text-field
                    :label="$t('Reply address')"
                    :value="emailCopy.reply_to_email"
                    :error-messages="errors.reply_to_email"
                    :placeholder="emailIntegration.reply_to_email"
                    @input="emailCopy.reply_to_email = $event"
                />
            </v-col>
            <v-col cols="12" class="pt-0 pb-2">
                <text-field
                    :label="$t('Sender name')"
                    :value="emailCopy.sender_name"
                    :placeholder="emailIntegration.sender_name"
                    @input="emailCopy.sender_name = $event"
                />
            </v-col>
            <v-col cols="12" class="pt-0 pb-2">
                <text-field
                    :label="$t('Who can use?')"
                    :value="$t('Client members')"
                    disabled
                />
            </v-col>
            <v-col cols="12" class="pt-3 pb-2">
                <switch-button
                    :value="emailCopy.is_default"
                    :label="$t('Client default address')"
                    @change="emailCopy.is_default = $event"
                />
            </v-col>
        </v-row>
        <template slot="footer">
            <danger-button
                @click="$emit('delete')"
            >
                {{ $t("Delete") }}
            </danger-button>
            <v-spacer />
            <primary-button @click="onSave">
                {{ $t("Save") }}
            </primary-button>
        </template>
    </Dialog>
</template>

<script>
import Dialog from "../../../components/Dialog.vue";
import {computed, onMounted, ref} from "@vue/composition-api";
import ApiEmailAutomationEmail from '@/api/email_automation/email_integration'
import { $t } from "@/i18n";
import { get, set } from '@/helpers/get-set'
import AccountModule from "@/store/modules/account";
import IntegrationButton from "@/components/Buttons/IntegrationButton";

export default {
    name: "ClientEmailsFieldEditDialog",
    components: {
        IntegrationButton,
        Dialog
    },
    props: {
        email: {
            type: Object,
            required: true
        },
        emailIntegration: {
            type: Object,
            required: true
        },
    },
    setup(props, ctx) {
        const emailCopy = ref(null)
        const errors = ref({
            reply_to_email: null
        });

        emailCopy.value = { ...props.email }

        if (!emailCopy.value.reply_to_email) {
            emailCopy.value.reply_to_email = props.emailIntegration.reply_to_email
        }

        if (!emailCopy.value.sender_name) {
            emailCopy.value.sender_name = props.emailIntegration.sender_name
        }

        const isValidEmail = (e) => {
            var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
            return String(e).search (filter) != -1;
        }

        const onSave = () => {
            if (emailCopy.value.reply_to_email !== '' && emailCopy.value.reply_to_email) {
                if (!isValidEmail(emailCopy.value.reply_to_email)) {
                    errors.value.reply_to_email = $t('Invalid e-mail')
                    return
                }
            }

            ctx.emit('save', emailCopy.value)
        }

        return {
            emailCopy,
            errors,
            onSave
        }
    }
};
</script>